<template>
    <div class="page products"  @scroll="pageScroll" ref="page">
        
        <div class="pageContainer">
            <div class="container">
                <h2 class="d-flex justify-content-between align-items-center mb-4">
                    <img :src="getStaticImage('icon-arrow-left.png')" @click="$router.go(-1)" alt="back">
                    <span>{{ $t('products.Brands') }}</span>
                    <span style="width: 35px"></span>
                </h2>
                
                <div class="row brandsIcons text-center">
                    <div class="col-6" @click="changeBrand('real')">
                        <img class="startAnimation" :src="getStaticImage('real_logo.png')"
                             :class="{active: ($route.query.brand === 'real' || !$route.query.brand ) }">
                    </div>
                    <div class="col-6" @click="changeBrand('finest')">
                        <img class="startAnimation" :src="getStaticImage('finestcall_logo_hr.jpg')"
                             :class="{active: ($route.query.brand === 'finest') }">
                    </div>
                    <div class="col-12 mt-3">
                        <div class="line" :class="$route.query.brand"></div>
                    </div>
                </div>
                
                <transition-group
                    enter-active-class="fadeInRight"
                    leave-active-class="fadeOutLeft"
                    tag="div"
                    class="brandsBox"
                    id="brandBox"
                    mode=""
                >
                    <Real v-if="( $route.query.brand === 'real' || !$route.query.brand )" :key="1"></Real>
                    <Finest v-if="( $route.query.brand === 'finest' && !$route.query.collection)" :key="2"></Finest>
                    <FinestCollection v-if="( $route.query.brand === 'finest' && $route.query.collection)"
                                      :key="3"></FinestCollection>
                    
                </transition-group>
            
            </div>
        </div>
    </div>
</template>

<script>

    import pageMixin from "../mixins/page";

    import Real from "../components/brands/Real"
    import Finest from "../components/brands/Finest"
    import FinestCollection from "../components/brands/FinestCollection";
    
    

    export default {
        name: 'Products',
        mixins: [pageMixin],
        components: {Real, Finest, FinestCollection},
        data() {
            return {
                collection: ""
            }
        },
        methods: {
            changeBrand(brand) {
                this.$router.push({name: "products", query: {brand: brand}});
            }
        },
        created() {
            if (!this.$route.query.brand && !this.$route.query.product) {
                this.$router.push({name: "products", query: {brand: "real"}})
            }
        }

    }
</script>

